// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Assets from "../../assets/Assets.bs.jsx";
import * as Styles from "../../styles/components/Styles.bs.jsx";
import * as HtmlEntities from "../../utils/HtmlEntities.bs.jsx";
import * as JsxRuntime from "react/jsx-runtime";
import LoadingFullscreenModuleCss from "./LoadingFullscreen.module.css";

let classes = LoadingFullscreenModuleCss;

function LoadingFullscreen(props) {
  return <div
    className={Styles.page.centered}
  >
    <div
      className={classes.container}
    >
      <img
        alt={""}
        src={Assets.pouring}
      />
      <p>
        {`Čepuju kilobajty ` + HtmlEntities.hellip}
      </p>
    </div>
  </div>;
}

let make = LoadingFullscreen;

export {
  classes,
  make,
}
/* classes Not a pure module */
